if (document.body.id === "WhoWeAre") {
	document.querySelectorAll("#support .map .pin").forEach(pin => {
		pin.addEventListener("click", function() {
			let active = !pin.classList.contains("active");

			document.querySelectorAll("#support .map .pin").forEach(pin => {
				pin.classList.remove("active");
			});

			this.classList.toggle("active", active);

			const map = document.querySelector("#support .map");

			if (active)
				setTimeout(() => map.classList.add("has-active"), 300);
			else
				map.classList.remove("has-active");
		});
	});
}